import React from 'react';

type Props = {
    className?: string;
};

const ClearIcon = ({ className }: Props) => (
    <svg className={`icon icon-clear ${className}`} viewBox="0 0 24 24">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM11.8232 13.2053C11.9209 13.1077 12.0792 13.1077 12.1768 13.2053L14.2181 15.2466C14.3157 15.3442 14.474 15.3442 14.5716 15.2466L15.2466 14.5716C15.3442 14.474 15.3442 14.3157 15.2466 14.2181L13.2053 12.1768C13.1077 12.0791 13.1077 11.9209 13.2053 11.8232L15.2466 9.78195C15.3442 9.68431 15.3442 9.52602 15.2466 9.42839L14.5716 8.75343C14.474 8.6558 14.3157 8.6558 14.2181 8.75343L12.1768 10.7947C12.0792 10.8923 11.9209 10.8923 11.8232 10.7947L9.78196 8.75343C9.68432 8.6558 9.52603 8.6558 9.4284 8.75343L8.75344 9.42839C8.65581 9.52602 8.65581 9.68431 8.75344 9.78195L10.7947 11.8232C10.8923 11.9209 10.8923 12.0791 10.7947 12.1768L8.75344 14.2181C8.65581 14.3157 8.65581 14.474 8.75344 14.5716L9.4284 15.2466C9.52603 15.3442 9.68432 15.3442 9.78196 15.2466L11.8232 13.2053Z"
        />
    </svg>
);

export default ClearIcon;
